import React, { Component } from 'react'
import FormIngresoMinimo from './FormIngresoMinimo'

class IngresoMinimo extends Component {
  render () {
    return (
      <div id='camiones-ingreso-minimo-container'>
        <FormIngresoMinimo />
      </div>
    )
  }
}

export default IngresoMinimo
